import { isSpinTheWheelLike } from "./gameTypes";

export function getGameDataName(game_type_code) {
    // Games set up like Spin The Wheel share its form data
    if (isSpinTheWheelLike(game_type_code)) return "spinTheWheelData";
    switch (game_type_code) {
      case "spin_the_wheel":
        return "spinTheWheelData";
      case "slot_machine":
        return "slotMachineData";
      case "scratch_card":
        return "scratchCardData";
      case "trivia":
        return "triviaData";
      default:
        return "";
    }
  }
  